import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OskariRPC from 'oskari-rpc';

import { mapKeys } from '../../config';

import './OskariMap.css';

const iframeSrc = `${mapKeys.OSKARI_ORIGIN}/hkp/published/fi/${mapKeys.OSKARI_KEY}`;

class MapComponent extends Component {
  constructor(props) {
    super(props);

    this.postRequestToChannel = this.postRequestToChannel.bind(this);
    this.addEventHandler = this.addEventHandler.bind(this);
  }

  componentDidMount() {
    this.channel = OskariRPC.connect(document.getElementById('oskari-map'), 'https://hkp.maanmittauslaitos.fi');
    this.channel.onReady(() => {
      this.addMarkersToMap();
      this.channel.handleEvent('MarkerClickEvent', this.markerClicked.bind(this));
      this.channel.handleEvent('AfterMapMoveEvent', this.getMapBbox.bind(this));

      if (this.props.selectedEvent) {
        const selectedEvent = this.props.events.find(event => event.id === this.props.selectedEvent);
        this.channel.postRequest('MapMoveRequest', [selectedEvent.x, selectedEvent.y, 5]);
      }
    });
  }

  componentWillReceiveProps(nextprops) {
    const nextProps = nextprops;
    // If one of the links from the yearview is clicked following operations are made
    if (nextProps.mapView.mapView === 'OPEN') {
      // Find the selected event among rest of the events
      const ret = this.props.events.find(event => event.id === nextProps.mapView.eventId);
      // Move the map according to the params
      this.moveMapWithOffset({ x: ret.x, y: ret.y });
      // Remember to reset the mapView action
      this.props.changeMapView(undefined, undefined);
    } else if (nextProps.mapView.mapView === 'OPEN_AND_SHOW') {
      const ret = this.props.events.find(event => event.id === nextProps.mapView.eventId);
      this.moveMapWithOffset({ x: ret.x, y: ret.y });
      // Select the clicked event in order to active information window
      this.props.selectEvent(nextProps.mapView.eventId);
      this.props.changeMapView(undefined, undefined);
    }
  }

  componentDidUpdate() {
    // Every component updates (filter changes) reset and fetch markers again
    this.removeMarkersFromMap();
    this.addMarkersToMap();
  }

  getMapBbox() {
    // Applies filter based on the current BBOX
    this.channel.getMapBbox(data => this.props.selectBbox(data));
  }

  moveMapWithOffset(coords) {
    const zoom = 5;
    const offset = 0;
    this.channel.postRequest('MapMoveRequest', [coords.x - offset, coords.y, zoom]);
  }

  removeMarkersFromMap() {
    this.channel.postRequest('MapModulePlugin.RemoveMarkersRequest', []);
  }

  addMarkersToMap() {
    this.props.events.forEach((feature) => {
      this.channel.postRequest('MapModulePlugin.AddMarkerRequest', [feature, feature.id]);
    });
  }

  markerClicked(data) {
    this.props.selectEvent(data.id);
  }

  /**
   * Wrapper to rpc channel request. Can be passed to child components.
   * @param {String} requestType
   * @param {Function} data
   */
  postRequestToChannel(requestType, data) {
    this.channel.postRequest(requestType, data);
  }

  /**
   * Wrapper to rpc channel handleEvent. Can be passed to child components.
   * @param {String} eventType
   * @param {Function} eventHandler
   */
  addEventHandler(eventType, eventHandler) {
    this.channel.onReady(() => this.channel.handleEvent(eventType, eventHandler));
  }

  render() {
    return (
      <div className="map-wrapper">
        <iframe id="oskari-map" src={iframeSrc} />
      </div>
    );
  }
}

MapComponent.defaultProps = {
  selectedEvent: undefined
};

MapComponent.propTypes = {
  events: PropTypes.array.isRequired,
  selectEvent: PropTypes.func.isRequired,
  selectBbox: PropTypes.func.isRequired,
  changeMapView: PropTypes.func.isRequired,
  selectedEvent: PropTypes.string,
  mapView: PropTypes.object.isRequired
};

export default MapComponent;



// WEBPACK FOOTER //
// ./src/components/map/OskariMap.jsx